import { Image, Label, FontIcon, Stack } from '@fluentui/react';
import React, { useContext } from 'react';
import styles from '../styles/pokemon.module.scss';
import GlobalContext from '../_contexts/GlobalContext';

export interface IHeaderInfoComponentProps {
}

const HeaderInfoComponent : React.FunctionComponent<IHeaderInfoComponentProps> = (props : IHeaderInfoComponentProps) => {
    const { Strings } = useContext(GlobalContext);

    return (
        <div className={`${styles.divTable} ${styles.headerInfoMain}`}>
            <div className={styles.divTableRow}>
                <div className={styles.divTableCell} style={{width:25}}>
                    <div className={styles.InfoImg1}></div>
                </div>
                <div className={styles.divTableCell}>
                    <Label className={styles.headerInfoLabel}>{Strings?.ProductsSleeved}</Label>
                </div>
            </div>
            <div className={styles.divTableRow}>
                <div className={styles.divTableCell} style={{width:25}}>
                    <div className={styles.InfoImg2}></div>
                </div>
                <div className={styles.divTableCell}>
                    <Label className={styles.headerInfoLabel}>{Strings?.TT}</Label>
                </div>
            </div>
            <div className={styles.divTableRow}>
                <div className={styles.divTableCell} style={{width:25}}>
                    <div className={styles.InfoImg3}></div>
                </div>
                <div className={styles.divTableCell}>
                    <Label className={styles.headerInfoLabel}>{Strings?.PaymentMethods}</Label>
                </div>
            </div>
            <div className={styles.divTableRow}>
                <div className={styles.divTableCell} style={{width:25}}>
                    <div className={styles.InfoImg4}></div>
                </div>
                <div className={styles.divTableCell}>
                    <Label className={styles.headerInfoLabel}>{Strings?.BonusProducts}</Label>
                </div>
            </div>
        </div>
    );
}

export default HeaderInfoComponent;